module.exports = __webpack_public_path__ + "static/media/Lo_boost_strip.f2b13e2c.png";